import React from 'react';
import QuickMarkPage from '../components/QuickMarkPage';

function getSourceFromDom() {
  if (typeof document === 'undefined') return '';
  return document.getElementById('pfandpirat-root')?.dataset?.quickMarkSource || '';
}

export function PublicQuickMarkApp() {
  const hash = String(window?.location?.hash || '').toLowerCase();
  const hashSource = hash.includes('/quick-mark') ? 'app' : '';
  const domSource = getSourceFromDom();
  const runtimeSource = window?.pfandpiratData?.quickMarkSource || '';

  return <QuickMarkPage standalone source={domSource || hashSource || runtimeSource || 'sticker'} />;
}

export default PublicQuickMarkApp;
